<style>
@import '../../custom/css/ver-dica.css';
</style>

<template>
  <div id="ver-produto" class="ver-dica">
    <div class="form-fields position-relative" v-if="this.produto !== null">
      <h1 class="title text-uppercase font-weight-bold">Ver Produto</h1>
      <hr class="linha-amarela" />
      <div class="form-group">
        <label for="titulo">Nome</label>
        <div class="text" id="nome">{{ produto[0].nome }}</div>
      </div>
      <div class="form-group">
        <label for="descricao">Descrição</label>
        <div class="text" id="descricao">{{ produto[0].descricao }}</div>
      </div>
      <div class="form-group">
        <div class="btn btn-success" @click="editarProduto()">Editar</div>
        <div class="btn btn-voltar-dicas" @click="voltarLista()">Voltar</div>
      </div>
    </div>
    <div class="form-fields" v-else>
      <h1 class="title text-uppercase">Esse produto não existe mais!</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ver-produto',
  data: () => ({
    dados: {},
  }),
  props: ['id'],
  computed: {
    ...mapState({
      produto: (state) => state.produto,
    }),
  },
  created() {
    this.$store.dispatch('showProduto', this.id);
  },
  activated() {
    this.$store.dispatch('showProduto', this.id);
  },
  methods: {
    editarProduto() {
      this.$router.push({
        name: 'administrador-editar-produto',
        params: { id: this.id },
      });
    },
    voltarLista() {
      this.$router.push({
        name: 'administrador-lista-produtos',
      });
    },
  },
};
</script>
